import type { JSX } from 'react'
import { Helmet as ReactHelmet } from 'react-helmet'

export function Helmet({ title }: { title: string }): JSX.Element {
  return (
    <ReactHelmet titleTemplate="%s | Seen Orbit">
      <title>{title}</title>
    </ReactHelmet>
  )
}
